module.exports = __webpack_public_path__ + "img/speaker_notes_off.e9d7b78c.svg";